import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import { useRef } from 'react';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { auto } from '@popperjs/core';
import Utility from '../../../../Utility/Utility'
let u = Utility;
import { getConsumedItems, getFileData } from '../Controller/BookingController';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../../Actions/AllAction';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import * as pdfjsLib from 'pdfjs-dist';

// Configure PDF.js worker
//pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js`;

// PDF Renderer Component
const PDFRenderer = ({ pdfUrl, index, onLoadComplete }) => {
  const [renderedPages, setRenderedPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const renderTasksRef = useRef([]);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    let objectUrl = null;

    const loadPdf = async () => {
      try {
        setLoading(true);
        setError(null);
        //console.log(`[Bill ${index + 1}] Loading PDF from:`, pdfUrl);

        // Fetch PDF through backend to bypass CORS
        const response = await getFileData({ file_url: pdfUrl });
        //console.log(`[Bill ${index + 1}] Backend response received`);

        if (!isMountedRef.current) return;

        if (!response || !response.data) {
          throw new Error('Failed to fetch PDF from backend');
        }

        // Convert Buffer to Uint8Array
        const bufferData = response.data;
        const uint8Array = new Uint8Array(bufferData.data || bufferData);

        // Create Blob from Uint8Array
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        objectUrl = URL.createObjectURL(blob);
        //console.log(`[Bill ${index + 1}] PDF converted to blob`);

        // Load PDF from object URL
        const loadingTask = pdfjsLib.getDocument({
          url: objectUrl,
          cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/cmaps/',
          cMapPacked: true
        });

        const pdf = await loadingTask.promise;
        if (!isMountedRef.current) return;

        //console.log(`[Bill ${index + 1}] PDF loaded, pages:`, pdf.numPages);

        // Render all pages to canvas elements
        const pages = [];
        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: 1.5 });

          // Create a new canvas for each page at original PDF size
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          canvas.style.display = 'block';
          canvas.style.border = '1px solid #e0e0e0';
          if (pageNum < pdf.numPages) {
            canvas.style.marginBottom = '10px';
          }

          // Render page to canvas
          const renderTask = page.render({
            canvasContext: context,
            viewport: viewport
          });

          renderTasksRef.current.push(renderTask);

          try {
            await renderTask.promise;
            if (!isMountedRef.current) return;
            //console.log(`[Bill ${index + 1}] Rendered page ${pageNum}/${pdf.numPages}`);
            pages.push(canvas);
          } catch (renderErr) {
            if (renderErr.name === 'RenderingCancelledException') {
              //console.log(`[Bill ${index + 1}] Rendering cancelled for page ${pageNum}`);
              return;
            }
            throw renderErr;
          }
        }

        if (isMountedRef.current) {
          setRenderedPages(pages);
          setLoading(false);
          // Notify parent that this PDF has finished loading
          if (onLoadComplete) {
            onLoadComplete(index, true);
          }
        }
      } catch (err) {
        console.error(`[Bill ${index + 1}] Error loading PDF:`, err);
        if (isMountedRef.current) {
          setError(err.message || 'Failed to load PDF');
          setLoading(false);
          // Notify parent even on error so it doesn't wait forever
          if (onLoadComplete) {
            onLoadComplete(index, false);
          }
        }
      } finally {
        // Clean up object URL
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
        }
      }
    };

    if (pdfUrl) {
      loadPdf();
    }

    // Cleanup function
    return () => {
      isMountedRef.current = false;
      // Cancel all ongoing render tasks
      renderTasksRef.current.forEach(task => {
        if (task && task.cancel) {
          task.cancel();
        }
      });
      renderTasksRef.current = [];
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [pdfUrl, index]);

  if (error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px' }}>
        <p style={{ color: '#856404', margin: '0 0 10px 0', fontWeight: 600 }}>Unable to load PDF</p>
        <p style={{ color: '#856404', margin: '0', fontSize: '12px' }}>{error}</p>
        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#007EE6', textDecoration: 'underline', fontSize: '13px', marginTop: '10px', display: 'inline-block' }}
        >
          Click here to view PDF directly
        </a>
      </div>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      {loading && (
        <div style={{ textAlign: 'center', padding: '40px', backgroundColor: '#f8f9fa' }}>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>Loading Bill {index + 1}...</div>
          <div style={{ width: '50px', height: '50px', border: '3px solid #f3f3f3', borderTop: '3px solid #007EE6', borderRadius: '50%', margin: '0 auto', animation: 'spin 1s linear infinite' }}></div>
        </div>
      )}
      {!loading && renderedPages.length > 0 && (
        <div style={{ width: '100%' }}>
          {renderedPages.map((canvas, idx) => (
            <div
              key={idx}
              ref={(el) => {
                if (el) {
                  // Clear any existing content first to prevent duplicates
                  while (el.firstChild) {
                    el.removeChild(el.firstChild);
                  }
                  el.appendChild(canvas);
                }
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const fmt = (num) => parseFloat(String(num || 0)).toFixed(2);
const cap = (str) =>
  str ? str.split(' ').map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ') : '';
const getCurrencySymbol = (code) => ({ INR: '₹', USD: '$', EUR: '€', GBP: '£' }[code] || code);

// Get currency name based on currency code
const getCurrencyName = (code) => {
  const currencyNames = {
    'INR': 'Rupees',
    'USD': 'Dollars',
    'EUR': 'Euros',
    'GBP': 'Pounds',
    'AED': 'Dirhams',
    'SAR': 'Riyals',
    'JPY': 'Yen',
    'CNY': 'Yuan',
    'AUD': 'Australian Dollars',
    'CAD': 'Canadian Dollars',
    'SGD': 'Singapore Dollars'
  };
  return currencyNames[code] || code;
};

// Convert number to words (Indian numbering system)
const numberToWords = (num, currencyCode) => {
  if (!num || isNaN(num)) return 'Zero';

  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

  const convertLessThanThousand = (n) => {
    if (n === 0) return '';
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + ones[n % 10] : '');
    return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + convertLessThanThousand(n % 100) : '');
  };

  const fullAmount = parseFloat(num);
  const amount = Math.floor(fullAmount);
  const decimal = Math.round((fullAmount - amount) * 100); // Get decimal part (paise/cents)

  if (amount === 0 && decimal === 0) return 'Zero';

  let result = '';

  // Convert main amount
  if (amount > 0) {
    // Crores
    if (amount >= 10000000) {
      result += convertLessThanThousand(Math.floor(amount / 10000000)) + ' Crore ';
    }

    // Lakhs
    const lakhs = Math.floor((amount % 10000000) / 100000);
    if (lakhs > 0) {
      result += convertLessThanThousand(lakhs) + ' Lakh ';
    }

    // Thousands
    const thousands = Math.floor((amount % 100000) / 1000);
    if (thousands > 0) {
      result += convertLessThanThousand(thousands) + ' Thousand ';
    }

    // Hundreds
    const remainder = amount % 1000;
    if (remainder > 0) {
      result += convertLessThanThousand(remainder);
    }

    result = result.trim() + ' ' + getCurrencyName(currencyCode);
  }

  // Add decimal part (paise/cents)
  if (decimal > 0) {
    const decimalName = currencyCode === 'INR' ? 'Paise' : 'Cents';
    const decimalWords = convertLessThanThousand(decimal).trim();
    if (amount > 0) {
      result += ' and ' + decimalWords + ' ' + decimalName;
    } else {
      result = decimalWords + ' ' + decimalName;
    }
  }

  return result;
};

// /**
//  * @param {{ invoiceData: any }} props
//  */
const GenerateInvoiceContent = (props) => {
  const data = props.invoiceData;
  const branchData = data?.booking_master_details?.BookingMasterBranchData;
  const hotelData = data?.booking_master_details?.BookingMasterHotelData;
  const cs = getCurrencySymbol(data?.currency || 'INR');
  const isEarlyCheckout = data?.booking_master_details?.book_status === 'Early Checkout';
  const noTax = data?.no_tax;
  const [isPrintScreen, setIsPrintScreen] = useState(false);
  const [pdfBase64String, setPdfBase64String] = useState("");
  const [resendQuotationDetailsModalFlag, setResendQuotationDetailsModalFlag] = useState(false)
  const [zoominzoomoutflag, setZoominzoomoutflag] = useState("");
  const [invoiceResponseData, setInvoiceResponseData] = useState({});
  const [showPrintOptionsModal, setShowPrintOptionsModal] = useState(false);
  const [selectedPrintOption, setSelectedPrintOption] = useState('both');
  const printComponentRef = useRef(null);

  // State to track PDF loading for posted_bills
  const [pdfLoadStatus, setPdfLoadStatus] = useState({});
  const [allPdfsLoaded, setAllPdfsLoaded] = useState(false);

  // Calculate total PDFs to load
  const totalPdfsToLoad = data?.posted_bills_invoice?.filter(url => url)?.length || 0;

  const pageStyle = `@media print {   
      @page {size: A4;  margin: 0;}   
      body {margin: 1cm;}
      .hide-on-print {display: none !important;}
      .hide-print-button {display: none !important;}
    }`;
  const divPrint = React.useRef(null);

  // Callback when a PDF finishes loading
  const handlePdfLoadComplete = (index, success) => {
    setPdfLoadStatus(prev => ({
      ...prev,
      [index]: { loaded: true, success }
    }));
  };

  // Check if all PDFs are loaded
  useEffect(() => {
    if (totalPdfsToLoad === 0) {
      // No PDFs to load, mark as ready immediately
      setAllPdfsLoaded(true);
    } else {
      const loadedCount = Object.keys(pdfLoadStatus).length;
      if (loadedCount >= totalPdfsToLoad) {
        // All PDFs have finished loading (success or error)
        setAllPdfsLoaded(true);
      }
    }
  }, [pdfLoadStatus, totalPdfsToLoad]);

  useEffect(() => {
    const handleBeforePrint = () => {
      setIsPrintScreen(true);
    };

    const handleAfterPrint = () => {
      setIsPrintScreen(false);
    };

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  //Initially set pdf image to save invoice - wait for all PDFs to load first
  useEffect(() => {
    // Don't proceed until all PDFs are loaded
    if (!allPdfsLoaded) return;

    // Add a small delay after PDFs are loaded to ensure DOM is fully updated
    const timer = setTimeout(async () => {
      const input = document.getElementById("invoiceId");
      if (!input) return;

      // Temporarily remove scrolling constraints if any (recommended)
      const prevOverflow = input.style.overflow;
      const prevHeight = input.style.height;
      input.style.overflow = "visible";
      input.style.height = "auto";

      try {
        const canvas = await html2canvas(input, {
          scale: Math.min(window.devicePixelRatio || 2, 2), // keep performance sane
          useCORS: true,
          allowTaint: true,
          backgroundColor: "#ffffff",
          logging: false,
          // If your invoice is inside a scroller, this helps capture full content:
          scrollX: 0,
          scrollY: -window.scrollY
        });

        // Restore styles
        input.style.overflow = prevOverflow;
        input.style.height = prevHeight;

        // A4 in mm
        const pdf = new jsPDF("l", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();   // 210mm - margins not included
        const pageHeight = pdf.internal.pageSize.getHeight(); // 297mm

        // Optional margins
        const marginX = 3; // mm
        const marginY = 3; // mm
        const usableWidth = pageWidth - marginX * 2;
        const usableHeight = pageHeight - marginY * 2;

        // Canvas -> PDF sizing
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // Scale canvas to fit usable PDF width
        const imgHeightOnPdf = (canvasHeight * usableWidth) / canvasWidth;

        // If content fits on one page, add directly
        if (imgHeightOnPdf <= usableHeight) {
          const imgData = canvas.toDataURL("image/png", 1.0);
          pdf.addImage(imgData, "PNG", marginX, marginY, usableWidth, imgHeightOnPdf, undefined, "FAST");
        } else {
          // MULTI-PAGE: slice the canvas into page-sized chunks
          const pxPerMm = canvasWidth / usableWidth; // pixels per mm at the scaled width
          const pageHeightPx = Math.floor(usableHeight * pxPerMm);

          let renderedHeightPx = 0;
          let pageIndex = 0;

          while (renderedHeightPx < canvasHeight) {
            const sliceHeightPx = Math.min(pageHeightPx, canvasHeight - renderedHeightPx);

            // Create a canvas slice
            const pageCanvas = document.createElement("canvas");
            pageCanvas.width = canvasWidth;
            pageCanvas.height = sliceHeightPx;

            const ctx = pageCanvas.getContext("2d");
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

            ctx.drawImage(
              canvas,
              0,
              renderedHeightPx,
              canvasWidth,
              sliceHeightPx,
              0,
              0,
              canvasWidth,
              sliceHeightPx
            );

            const imgData = pageCanvas.toDataURL("image/png", 1.0);

            // Only add a new page if it's NOT the first page
            if (pageIndex > 0) {
              pdf.addPage();
            }

            const sliceHeightMm = sliceHeightPx / pxPerMm; // convert slice height back to mm
            pdf.addImage(imgData, "PNG", marginX, marginY, usableWidth, sliceHeightMm, undefined, "FAST");

            renderedHeightPx += sliceHeightPx;
            pageIndex += 1;
          }
        }

        const base64String = pdf.output("datauristring");
        setPdfBase64String(base64String);
      } catch (err) {
        // Restore styles on error as well
        input.style.overflow = prevOverflow;
        input.style.height = prevHeight;
        console.error("PDF generation failed:", err);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [allPdfsLoaded]);

  ///download invoice pdf
  const downloadPdfDocument = async () => {
    props.loaderStateTrue();
    const input = document.getElementById('invoiceId');

    // Find all images with cross-origin sources and fetch via backend
    const images = input.querySelectorAll('img');
    const imagePromises = [];

    images.forEach((img) => {
      const src = img.src;
      // Check if it's a cross-origin URL (S3, external)
      if (src && (src.startsWith('http://') || src.startsWith('https://')) && !src.includes('data:image')) {
        const promise = getFileData({ file_url: src })
          .then((response) => {
            if (response && response.data) {
              // Convert Buffer to Uint8Array
              const bufferData = response.data;
              const uint8Array = new Uint8Array(bufferData.data || bufferData);

              // Create Blob and convert to base64
              const blob = new Blob([uint8Array], { type: 'image/jpeg' });
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                  resolve({
                    img: img,
                    originalSrc: src,
                    base64Src: reader.result
                  });
                };
                reader.readAsDataURL(blob);
              });
            }
            return null;
          })
          .catch((error) => {
            console.warn('Failed to fetch image via backend:', src, error);
            return null;
          });
        imagePromises.push(promise);
      }
    });

    // Wait for all images to be fetched and converted
    const results = await Promise.all(imagePromises);
    const imageReplacements = results.filter(r => r !== null);

    // Temporarily replace img src with base64
    imageReplacements.forEach(replacement => {
      replacement.img.src = replacement.base64Src;
    });

    // Small delay to ensure DOM updates
    setTimeout(async () => {
      try {
        // Use landscape orientation
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Add margins
        const marginX = 10;
        const marginY = 10;
        const usableWidth = pdfWidth - marginX * 2;
        const usableHeight = pdfHeight - marginY * 2;

        // Track if we've added any content to PDF
        let hasContent = false;

        // Capture Stay Bill Section
        const stayBillSection = document.querySelector('.invoice-page-container');
        if (stayBillSection && selectedPrintOption !== 'outsource') {
          const prevOverflow = stayBillSection.style.overflow;
          const prevHeight = stayBillSection.style.height;
          stayBillSection.style.overflow = "visible";
          stayBillSection.style.height = "auto";

          const stayCanvas = await html2canvas(stayBillSection, {
            scale: Math.min(window.devicePixelRatio || 2, 2),
            useCORS: true,
            allowTaint: true,
            backgroundColor: "#ffffff",
            logging: false,
            scrollX: 0,
            scrollY: -window.scrollY
          });

          stayBillSection.style.overflow = prevOverflow;
          stayBillSection.style.height = prevHeight;

          const canvasWidth = stayCanvas.width;
          const canvasHeight = stayCanvas.height;
          const imgHeightOnPdf = (canvasHeight * usableWidth) / canvasWidth;

          if (imgHeightOnPdf <= usableHeight) {
            const stayImgData = stayCanvas.toDataURL('image/png', 1.0);
            pdf.addImage(stayImgData, 'PNG', marginX, marginY, usableWidth, imgHeightOnPdf, undefined, 'FAST');
            hasContent = true;
          } else {
            // Get all table elements to find safe break points
            const tables = stayBillSection.querySelectorAll('table');
            const tablePositions = [];

            tables.forEach(table => {
              const rect = table.getBoundingClientRect();
              const sectionRect = stayBillSection.getBoundingClientRect();
              const relativeTop = rect.top - sectionRect.top + stayBillSection.scrollTop;
              const relativeBottom = relativeTop + rect.height;
              tablePositions.push({ top: relativeTop, bottom: relativeBottom });
            });

            const pxPerMm = canvasWidth / usableWidth;
            const pageHeightPx = Math.floor(usableHeight * pxPerMm);
            let renderedHeightPx = 0;
            let pageIndex = 0;

            while (renderedHeightPx < canvasHeight) {
              let sliceHeightPx = Math.min(pageHeightPx, canvasHeight - renderedHeightPx);

              // Check if we're about to cut through a table
              const cutPoint = renderedHeightPx + sliceHeightPx;
              const scale = canvasHeight / stayBillSection.scrollHeight;

              for (const tablePos of tablePositions) {
                const tableTopPx = tablePos.top * scale;
                const tableBottomPx = tablePos.bottom * scale;

                // If cut point is inside a table, adjust to break before the table
                if (cutPoint > tableTopPx && cutPoint < tableBottomPx) {
                  const adjustedHeight = tableTopPx - renderedHeightPx;
                  if (adjustedHeight > pageHeightPx * 0.3) { // Only adjust if we have at least 30% of page
                    sliceHeightPx = adjustedHeight;
                  }
                  break;
                }
              }

              const pageCanvas = document.createElement("canvas");
              pageCanvas.width = canvasWidth;
              pageCanvas.height = sliceHeightPx;

              const ctx = pageCanvas.getContext("2d");
              ctx.fillStyle = "#ffffff";
              ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

              ctx.drawImage(stayCanvas, 0, renderedHeightPx, canvasWidth, sliceHeightPx, 0, 0, canvasWidth, sliceHeightPx);

              const imgData = pageCanvas.toDataURL("image/png", 1.0);

              if (pageIndex > 0) {
                pdf.addPage();
              }

              const sliceHeightMm = sliceHeightPx / pxPerMm;
              pdf.addImage(imgData, "PNG", marginX, marginY, usableWidth, sliceHeightMm, undefined, "FAST");

              renderedHeightPx += sliceHeightPx;
              pageIndex += 1;
            }
            hasContent = true;
          }
        }

        // Fetch and append Food Invoice PDFs
        const postedBillsInvoice = data?.posted_bills_invoice || [];
        if (postedBillsInvoice.length > 0) {
          for (const pdfUrl of postedBillsInvoice) {
            if (pdfUrl && typeof pdfUrl === 'string') {
              try {
                const response = await getFileData({ file_url: pdfUrl });
                if (response && response.data) {
                  const bufferData = response.data;
                  const uint8Array = new Uint8Array(bufferData.data || bufferData);
                  const blob = new Blob([uint8Array], { type: 'application/pdf' });
                  const objectUrl = URL.createObjectURL(blob);

                  const loadingTask = pdfjsLib.getDocument({
                    url: objectUrl,
                    cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/cmaps/',
                    cMapPacked: true
                  });

                  const foodPdf = await loadingTask.promise;

                  for (let pageNum = 1; pageNum <= foodPdf.numPages; pageNum++) {
                    const page = await foodPdf.getPage(pageNum);
                    const viewport = page.getViewport({ scale: 2.0 });
                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    await page.render({
                      canvasContext: context,
                      viewport: viewport
                    }).promise;

                    const pageImgData = canvas.toDataURL('image/png');
                    const canvasAspectRatio = canvas.width / canvas.height;
                    const pageAspectRatio = pdfWidth / pdfHeight;

                    let imgWidth, imgHeight;
                    if (canvasAspectRatio > pageAspectRatio) {
                      imgWidth = pdfWidth;
                      imgHeight = pdfWidth / canvasAspectRatio;
                    } else {
                      imgHeight = pdfHeight;
                      imgWidth = pdfHeight * canvasAspectRatio;
                    }

                    // Only add new page if we already have content
                    if (hasContent) {
                      pdf.addPage();
                    } else {
                      hasContent = true;
                    }

                    const xPosition = (pdfWidth - imgWidth) / 2;
                    const yPosition = (pdfHeight - imgHeight) / 2;
                    pdf.addImage(pageImgData, 'PNG', xPosition, yPosition, imgWidth, imgHeight);
                  }

                  URL.revokeObjectURL(objectUrl);
                }
              } catch (error) {
                console.error('Error fetching food invoice PDF:', pdfUrl, error);
              }
            }
          }
        }

        // Restore original image sources
        imageReplacements.forEach(replacement => {
          replacement.img.src = replacement.originalSrc;
        });

        pdf.save(`${data.invoiceId}.pdf`);
        props.loaderStateFalse();
      } catch (error) {
        // Restore original image sources on error
        imageReplacements.forEach(replacement => {
          replacement.img.src = replacement.originalSrc;
        });
        console.error('PDF generation error:', error);
        props.loaderStateFalse();
      }
    }, 100);
  };

  const sendInvoiceFn = () => {
    setResendQuotationDetailsModalFlag(true);
  }

  const handlePrintButtonClick = () => {
    if (data?.posted_bills_invoice?.length > 0) {
      setShowPrintOptionsModal(true);
    } else {
      setTimeout(() => {
        if (printComponentRef.current) {
          printComponentRef.current.click();
        }
      }, 100);
    }
  }

  const handlePrintOptionSelect = (option) => {
    setSelectedPrintOption(option);
  }


  const handleConfirmPrint = () => {
    setShowPrintOptionsModal(false);
    // console.log("selectedPrintOption", selectedPrintOption);

    const stayBillSection = document.querySelector(".stay-bill-section");
    const otherBillSection = document.querySelector(".other-bill-section");
    const otherBillSectionHeader = document.querySelector(".other-bill-section-header");
    const invoiceContainer = document.getElementById("invoiceId");

    let stayBillOriginalStyles = {};
    let otherBillOriginalStyles = {};
    let otherBillHeaderOriginalStyles = {};
    let containerOriginalStyles = {};

    let removedStayBill = null;
    let stayBillParent = null;
    let stayBillNextSibling = null;

    // ================================
    // OUTSOURCE PRINT (Hide Stay Bill)
    // ================================
    if (stayBillSection && selectedPrintOption === "outsource") {
      // Store reference to parent and position for restoration
      stayBillParent = stayBillSection.parentNode;
      stayBillNextSibling = stayBillSection.nextSibling;

      // Temporarily remove from DOM
      removedStayBill = stayBillParent.removeChild(stayBillSection);

      // Hide the page wrapper div to prevent blank page from minHeight
      if (stayBillParent) {
        stayBillParent.style.display = "none";
        stayBillParent.style.minHeight = "0";
        stayBillParent.style.height = "0";
        //stayBillParent.style.margin = "0";
        stayBillParent.style.padding = "0";
      }

      if (otherBillSectionHeader) {
        otherBillHeaderOriginalStyles = {
          display: otherBillSectionHeader.style.display,
        };
        otherBillSectionHeader.style.display = "none";
      }

      if (invoiceContainer) {
        containerOriginalStyles = {
          paddingTop: invoiceContainer.style.paddingTop,
          paddingBottom: invoiceContainer.style.paddingBottom,
          margin: invoiceContainer.style.margin,
        };

        invoiceContainer.style.paddingTop = "0px";
        invoiceContainer.style.paddingBottom = "0px";
        invoiceContainer.style.margin = "0px";
      }
    }

    // ============================
    // STAY PRINT (Hide Food Bill)
    // ============================
    if (otherBillSection && selectedPrintOption === "stay") {
      otherBillOriginalStyles = {
        display: otherBillSection.style.display,
        height: otherBillSection.style.height,
        overflow: otherBillSection.style.overflow,
        visibility: otherBillSection.style.visibility,
      };

      otherBillSection.style.display = "none";
      otherBillSection.style.height = "0";
      otherBillSection.style.overflow = "hidden";
      otherBillSection.style.visibility = "hidden";

      if (otherBillSectionHeader) {
        otherBillHeaderOriginalStyles = {
          display: otherBillSectionHeader.style.display,
        };
        otherBillSectionHeader.style.display = "none";
      }
    }

    // ===========================================
    // WAIT UNTIL ALL BILLS FULLY RENDERED
    // (Outsource + Both needs this)
    // ===========================================
    const waitForBillsToLoad = (callback) => {
      const targetSection =
        selectedPrintOption === "stay" ? stayBillSection : otherBillSection;

      if (!targetSection) {
        callback();
        return;
      }

      let lastHeight = 0;
      let stableCount = 0;

      const checkBills = () => {
        const currentHeight = targetSection.scrollHeight;

        if (currentHeight > 0 && currentHeight === lastHeight) {
          stableCount++;
        } else {
          stableCount = 0;
        }

        lastHeight = currentHeight;

        if (stableCount >= 3) {
          callback();
        } else {
          setTimeout(checkBills, 200);
        }
      };

      checkBills();
    };

    // ============================
    // RESTORE FUNCTION
    // ============================
    const restoreUI = () => {
      if (selectedPrintOption === "outsource" && removedStayBill && stayBillParent) {
        // Restore the page wrapper div styles
        if (stayBillParent) {
          stayBillParent.style.display = "";
          stayBillParent.style.minHeight = "";
          stayBillParent.style.height = "";
          stayBillParent.style.margin = "10px auto 0px";
          stayBillParent.style.padding = "";
        }

        // Restore the stay bill section back to DOM
        if (stayBillNextSibling) {
          stayBillParent.insertBefore(removedStayBill, stayBillNextSibling);
        } else {
          stayBillParent.appendChild(removedStayBill);
        }

        if (invoiceContainer) {
          invoiceContainer.style.paddingTop = containerOriginalStyles.paddingTop || "";
          invoiceContainer.style.paddingBottom = containerOriginalStyles.paddingBottom || "";
          invoiceContainer.style.margin = containerOriginalStyles.margin || "";
        }

        if (otherBillSectionHeader) {
          otherBillSectionHeader.style.display =
            otherBillHeaderOriginalStyles.display || "";
        }
      }

      if (otherBillSection && selectedPrintOption === "stay") {
        otherBillSection.style.display = otherBillOriginalStyles.display || "";
        otherBillSection.style.height = otherBillOriginalStyles.height || "";
        otherBillSection.style.overflow = otherBillOriginalStyles.overflow || "";
        otherBillSection.style.visibility = otherBillOriginalStyles.visibility || "";

        if (otherBillSectionHeader) {
          otherBillSectionHeader.style.display =
            otherBillHeaderOriginalStyles.display || "";
        }
      }
    };

    // ============================
    // TRIGGER PRINT
    // ============================
    const triggerPrint = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (printComponentRef.current) {
            printComponentRef.current.click();
          }
        });
      });

      // restore after print
      window.onafterprint = () => {
        restoreUI();
        window.onafterprint = null;
      };

      // fallback restore
      setTimeout(() => {
        restoreUI();
      }, 1500);
    };

    // ============================
    // FINAL FLOW
    // ============================
    setTimeout(() => {
      if (selectedPrintOption === "outsource" || selectedPrintOption === "both") {
        waitForBillsToLoad(() => {
          triggerPrint();
        });
      } else {
        triggerPrint();
      }
    }, 300);
  };


  const handleClosePrintModal = () => {
    setShowPrintOptionsModal(false);
    setSelectedPrintOption('both');
  }

  const resendQuotationDetailsModalCloseFn = () => {
    setResendQuotationDetailsModalFlag(false)
  }

  const resendQuotationDetailsCloseFromChild = () => {
    setResendQuotationDetailsModalFlag(false)
  }

  //modal zoomin fn
  const zoominFunction = () => {
    let zoominzoomoutflag = "zoominzoomoutclass"
    setZoominzoomoutflag(zoominzoomoutflag)
  }

  //modal zoomout fn
  const zoomoutFunction = () => {
    let zoominzoomoutflag = ""
    setZoominzoomoutflag(zoominzoomoutflag)
  }

  // State for consumed items data from API
  const [consumedItemsDataFromAPI, setConsumedItemsDataFromAPI] = useState(null);

  let branchLogoObj = null;
  try {
    const logoData = data?.booking_master_details?.BookingMasterBranchData?.branch_logo;
    if (logoData && typeof logoData === "string") {
      branchLogoObj = JSON.parse(logoData);
    }
  } catch (error) {
    branchLogoObj = null;
  }

  const getRoomRows = (roomData) => {
    const rows = [];
    if (!roomData) return rows;
    Object.values(roomData).forEach((outer) => {
      Object.values(outer).forEach((r) => rows.push(r));
    });
    return rows;
  };

  const roomRows = getRoomRows(data?.room_type_booking_details);
  const earlyRoomRows = getRoomRows(data?.early_checkout_booking_details);
  // Determine which tax columns have values
  const hasCGST = roomRows.some(r => Number(r.cgst_amount || 0) > 0);
  const hasSGST = roomRows.some(r => Number(r.sgst_amount || 0) > 0);
  const hasIGST = roomRows.some(r => Number(r.igst_amount || 0) > 0);

  const consumedItems = data?.consumed_items_data?.consumption_item || [];
  const damagedItems = data?.consumed_items_data?.damage_item || [];
  const allItems = [
    ...consumedItems.map((item) => ({
      ...item,
      type: item.unit || 'pcs',
      amount: parseFloat(item.quantity) * parseFloat(item.charge_per_unit),
      gst: parseFloat(item.gst_percentage || 0),
      cgst: parseFloat(item.cgst_amount || 0),
      sgst: parseFloat(item.sgst_amount || 0),
      total:
        parseFloat(item.quantity) * parseFloat(item.charge_per_unit) +
        parseFloat(item.cgst_amount || 0) +
        parseFloat(item.sgst_amount || 0),
    })),
    ...damagedItems.map((item) => ({
      ...item,
      item_name: `${item.item_name} (Damaged)`,
      type: 'damage',
      amount: parseFloat(item.quantity) * parseFloat(item.charge_per_unit),
      gst: 0,
      cgst: 0,
      sgst: 0,
      total: parseFloat(item.quantity) * parseFloat(item.charge_per_unit),
    })),
  ];

  // Fetch consumed items from API when component loads
  useEffect(() => {
    const fetchConsumedItems = async () => {
      const showConsumedItems = data?.booking_master_details?.is_checkout_settled || false;

      if (data?.booking_master_details?.id && showConsumedItems) {
        try {
          const response = await getConsumedItems({ booking_id: data.booking_master_details.id });
          if (response && response.success && response.data) {
            setConsumedItemsDataFromAPI(response.data);
          }
        } catch (error) {
          console.error('Error fetching consumed items:', error);
        }
      }
    };

    if (Object.keys(data || {}).length > 0) {
      fetchConsumedItems();
    }
  }, [data]);

  // Consumption/Damage Item Details (separate detailed section)
  // Use API data if available, otherwise fall back to data from invoiceData
  const consumedItemsData = consumedItemsDataFromAPI || data?.consumed_items_data;
  const detailedConsumptionItems = consumedItemsData?.consumption_item || [];
  const detailedDamageItems = consumedItemsData?.damage_item || [];
  const hasDetailedItems = detailedConsumptionItems.length > 0 || detailedDamageItems.length > 0;

  // Calculate subtotals for detailed items
  let detailedSubtotalAmount = 0;
  let detailedSubtotalCGST = 0;
  let detailedSubtotalSGST = 0;
  let detailedSubtotalTotal = 0;

  // Process consumption items
  detailedConsumptionItems.forEach(item => {
    const amount = Number(item.total_cost || 0);
    const cgst = Number(item.cgst_amount || 0);
    const sgst = Number(item.sgst_amount || 0);
    detailedSubtotalAmount += amount;
    detailedSubtotalCGST += cgst;
    detailedSubtotalSGST += sgst;
    detailedSubtotalTotal += Number(item.total_cost_including_tax || 0);
  });

  // Process damage items (use total_charge instead of total_cost)
  detailedDamageItems.forEach(item => {
    const amount = Number(item.total_charge || 0);
    detailedSubtotalAmount += amount;
    detailedSubtotalTotal += amount; // Damage items typically don't have tax
  });

  const creditedPayments = data?.booking_credited_payments || [];
  const debitedPayments = data?.booking_debited_payments || [];
  const earlyFoodHash = data?.early_date_wise_food_hash || {};

  // Extra service notations
  const extraService = data?.extra_notations && Array.isArray(data.extra_notations) ? data.extra_notations : [];

  // Calculate total notation amounts
  let totalNotationAmount = 0;
  if (extraService.length > 0) {
    totalNotationAmount = extraService.reduce((acc, service) => {
      if (!service?.hasOwnProperty('note_type') || service.note_type !== 'BILL_POSTING') {
        return acc + Number(service.amount);
      }
      return acc;
    }, 0);
  }

  let totalNotationAmountWithTax = 0;
  if (extraService.length > 0) {
    totalNotationAmountWithTax = extraService.reduce((acc, service) => {
      if (!service?.hasOwnProperty('note_type') || service.note_type !== 'BILL_POSTING') {
        const tax = (Number(service?.service_tax_percentage || 0) / 100) * Number(service.amount);
        return acc + Number(service?.amount) + tax;
      }
      return acc;
    }, 0);
  }

  let totalNotationAmountWithTaxBillPosting = 0;
  if (extraService.length > 0) {
    totalNotationAmountWithTaxBillPosting = extraService.reduce((acc, service) => {
      if (service?.note_type === 'BILL_POSTING') {
        const tax = (Number(service?.service_tax_percentage || 0) / 100) * Number(service.amount);
        return acc + Math.round(Number(service?.amount) + tax);
      }
      return acc;
    }, 0);
  }

  // Payable Service Details UI (non-bill posting)
  const payableServiceDetailsUi = () => {
    let extraNotationsDetails = data?.extra_notations || [];
    extraNotationsDetails = Array.isArray(extraNotationsDetails)
      ? extraNotationsDetails.filter((obj) => !obj?.hasOwnProperty('note_type') || obj.note_type !== 'BILL_POSTING')
      : [];

    return extraNotationsDetails.map((obj, i) => (
      <tr key={i}>
        <td style={cell({ textAlign: 'center' })}>{obj.book_date ? moment(obj.book_date).format('DD-MM-YYYY') : ''}</td>
        <td style={cell({ textAlign: 'left', maxWidth: 300 })}>{obj.description}</td>

        <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(obj.amount)}</td>
        {!noTax && (
          <>
            <td style={cell({ textAlign: 'center' })}>{fmt(obj.service_tax_percentage || 0)}%</td>
            <td style={cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' })}>
              {fmt(Number(obj.amount) + (Number(obj.amount) * Number(obj.service_tax_percentage || 0) / 100))}
            </td>
          </>
        )}
        {noTax && (
          <td style={cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' })}>
            {fmt(obj.amount)}
          </td>
        )}
      </tr>
    ));
  };

  // Payable Service Details UI (bill posting)
  const payableServiceDetailsBillPostingUi = () => {
    let extraNotationsDetails = data?.extra_notations || [];
    extraNotationsDetails = Array.isArray(extraNotationsDetails)
      ? extraNotationsDetails.filter((obj) => obj && obj.note_type === 'BILL_POSTING')
      : [];

    return extraNotationsDetails.map((obj, i) => (
      <tr key={i}>
        <td style={cell({ textAlign: 'center' })}>{obj.book_date ? moment(obj.book_date).format('DD-MM-YYYY') : ''}</td>
        <td style={cell({ textAlign: 'left' })}>{obj.description}</td>

        <td style={cell({ textAlign: 'center' })}>{fmt(obj.service_tax_percentage || 0)}%</td>
        <td style={cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' })}>
          {fmt(Math.round(Number(obj.amount) + (Number(obj.amount) * Number(obj.service_tax_percentage || 0) / 100)))}
        </td>
      </tr>
    ));
  };

  const roomBaseTotal = Number(data?.total_amount_without_gst || 0);
  const roomDiscount = Number(data?.special_discount || 0);
  const roomCgst = Number(data?.cgst_amount || 0);
  const roomSgst = Number(data?.sgst_amount || 0);
  const roomTotal = roomBaseTotal - roomDiscount + roomCgst + roomSgst;
  const consumedSubtotal = allItems.reduce((s, i) => s + i.amount, 0);
  const consumedTaxTotal = allItems.reduce((s, i) => s + i.cgst + i.sgst, 0);
  const consumedTotal = allItems.reduce((s, i) => s + i.total, 0);
  const totalDebited = debitedPayments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);

  let bankDetails = null;
  try {
    if (branchData?.bank_details) bankDetails = JSON.parse(branchData.bank_details);
  } catch (e) { }

  // Check if any room has proportionate discount
  const hasProportionateDiscount = roomRows.some(r => Number(r.proportionate_discount || 0) > 0);

  // Food calculations
  const foodBaseAmount = Number(data?.food_amount || 0);
  const foodDiscount = Number(data?.special_discount_for_food || 0);
  const foodCgst = Number(data?.fcgst_amount || 0);
  const foodSgst = Number(data?.fsgst_amount || 0);
  const foodIgst = Number(data?.fgst_amount || 0);
  const foodTotal = foodBaseAmount - foodDiscount + foodCgst + foodSgst + foodIgst;
  const hasFoodData = Object.keys(data?.date_wise_food_hash || {}).length > 0;

  // --- STYLES ---
  const b = '1px solid #333';
  const bLight = '1px solid #999';
  const bDot = '1px solid #ccc';
  const borderLight = '1px solid #bbb';

  const page = {
    width: '203mm',
    minHeight: '290mm',
    margin: '10px auto 0px',
    padding: 0,
    backgroundColor: '#fff',
    fontFamily: 'Poppins-Regular',
    color: '#222',
    fontSize: 11,
    lineHeight: 1.2,
    boxSizing: 'border-box',
    border: '2px solid #333',
  };

  const cell = (extra) => ({
    padding: '2px 4px',
    fontSize: 11,
    borderBottom: bDot,
    borderRight: bDot,
    verticalAlign: 'top',
    ...(extra || {}),
  });

  const thStyle = (extra) => ({
    padding: '3px 4px',
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    borderBottom: b,
    borderRight: bDot,
    textAlign: 'center',
    backgroundColor: '#f5f5f5',
    ...(extra || {}),
  });

  const sectionTitle = (title) => (
    <div
      style={{
        fontSize: 11,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        padding: '3px 6px',
        borderTop: b,
        borderBottom: b,
        marginTop: 0,
        backgroundColor: '#f9f9f9',
      }}
    >
      {title}
    </div>
  );

  const fieldRow = (label, value) => (
    <div style={{ display: 'flex', padding: '2px 6px', borderBottom: bDot }}>
      <span
        style={{
          width: 90,
          fontSize: 11,
          color: 'rgb(34, 34, 34)',
          fontWeight: 400,
          textTransform: 'uppercase',
        }}
      >
        {label}
      </span>
      <span style={{ flex: 1, fontSize: 11, fontWeight: 300, color: 'rgb(85, 85, 85)' }}>: {value || '—'}</span>
    </div>
  );

  const summaryRow = (label, value, bold, border) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '2px 6px',
        borderBottom: border ? b : bDot,
        fontWeight: bold ? 600 : 400,
        fontSize: bold ? 12 : 11,
      }}
    >
      <span>{label}</span>
      <span style={{ fontFamily: 'Poppins-Regular', paddingLeft: 6 }}>{value}</span>
    </div>
  );

  const VariantViewPanel = ({ variants = [] }) => {
    const mealPlanCodes = variants
      .filter(comp => comp?.code)
      .map(comp => comp.code)
      .join(', ');

    return mealPlanCodes ? (
      <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>
        ({mealPlanCodes})
      </div>
    ) : null;
  };

  return (
    <div className='innerbodydimension' style={{ backgroundColor: '#e8e8e8', padding: '5px 0' }}>
      {/* Print HTML Start here */}
      <div className='invoiceBodyScroll' ref={divPrint} id="invoiceId">
        <div style={page} className="invoice-page-container">
          <div style={{ width: '100%', display: 'inline-block' }} className="stay-bill-section">
            {/* ===== HEADER ===== */}
            <div
              style={{
                borderBottom: '2px solid #333',
                padding: '8px 12px',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: '80%' }}>
                {branchLogoObj?.file_obj ? (
                  <img
                    src={branchLogoObj.file_obj}
                    style={{ width: 'auto', height: '70px' }}
                  />
                ) : (
                  <img
                    src={require('../../../../Utility/Public/images/hotel.png')}
                    style={{ width: 'auto', height: '70px' }}
                  />
                )}
                <div style={{ fontSize: 11, color: '#555', paddingLeft: '10px', lineHeight: 1.3 }}>
                  <div style={{ color: '#323232', fontSize: 17, fontWeight: 600, display: 'inline-block', width: '100%' }}>
                    {data.hasOwnProperty('booking_master_details') && data.booking_master_details && data.booking_master_details?.hasOwnProperty('BookingMasterBranchData') && data.booking_master_details?.BookingMasterBranchData && data.booking_master_details?.BookingMasterBranchData.hasOwnProperty('branch_name') && data.booking_master_details?.BookingMasterBranchData?.branch_name ? data.booking_master_details?.BookingMasterBranchData?.branch_name : ""}
                  </div>
                  {branchData?.address1 || `${cap(branchData?.city || '')}, ${branchData?.zip || ''}`}
                  {branchData?.contact1 && (
                    <>
                      <br />
                      {branchData.contact1.includes('+') ? branchData.contact1 : '+' + branchData.contact1}
                    </>
                  )}
                  {branchData?.email1 && (
                    <>
                      <br />
                      {branchData.email1}
                    </>
                  )}

                  {hotelData?.gstin_number && (
                    <div style={{ fontSize: 11, marginTop: 1 }}>
                      <span style={{ fontWeight: 600 }}>GSTIN:</span> {hotelData.gstin_number}
                      {branchData?.state && (
                        <>
                          {' '}
                          | <span style={{ fontWeight: 600 }}>State:</span> {cap(branchData.state)}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 800,
                    letterSpacing: 2,
                    textTransform: 'uppercase',
                    borderBottom: '2px solid #333',
                    paddingBottom: 2,
                    display: 'inline-block',
                  }}
                >
                  {props.paymentDetailsResend ? 'PAYMENT DETAILS' : 'TAX INVOICE'}
                </div>
                {!props.paymentDetailsResend && (
                  <div style={{ fontSize: 11, marginTop: 3, color: '#555' }}>
                    <span style={{ fontWeight: 600 }}>No:</span> {data?.booking_master_details?.invoice_number || '—'}
                  </div>
                )}
                <div style={{ fontSize: 11, color: '#555' }}>
                  <span style={{ fontWeight: 600 }}>Date:</span>{' '}
                  {data?.booking_date ? moment(data.booking_date).format('DD-MM-YYYY') : '—'}
                </div>
              </div>
            </div>

            {/* ===== BILL TO / BOOKING INFO ===== */}
            <div style={{ display: 'flex', borderBottom: b }}>
              <div style={{ flex: 1, borderRight: b }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    padding: '3px 6px',
                    borderBottom: b,
                    backgroundColor: '#f9f9f9',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Bill To
                </div>
                {fieldRow('Guest', data?.booking_master_details?.customer_name || '')}
                {fieldRow('Phone', data?.booking_master_details?.customer_phone || '')}
                {data?.booking_master_details?.customer_email && fieldRow('Email', data?.booking_master_details?.customer_email || '')}
                {data?.booking_master_details?.company_name && fieldRow(
                  'Co. Name',
                  data?.booking_master_details?.company_name || ''
                )}
                {data?.booking_master_details?.customer_gstin_no &&
                  fieldRow('GSTIN', data.booking_master_details?.customer_gstin_no)}

                {data?.booking_master_details?.company_address && fieldRow(
                  'Co. Address',
                  data?.booking_master_details?.company_address || ''
                )}
                {data?.booking_master_details?.customer_address && fieldRow(
                  'Cust. Address',
                  data?.booking_master_details?.customer_address || ''
                )}
              </div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    padding: '3px 6px',
                    borderBottom: b,
                    backgroundColor: '#f9f9f9',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Booking Details
                </div>
                {fieldRow('Booking ID', data?.booking_id || '')}
                {/* {fieldRow('Status', data?.booking_master_details?.book_status || '')} */}
                {fieldRow('Checked-In', data?.checked_in ? moment(data.checked_in).format('DD-MM-YYYY hh:mm A') : '')}
                {fieldRow('Checked-Out', data?.checked_out ? moment(data.checked_out).format('DD-MM-YYYY hh:mm A') : '')}
                {data?.all_checkin_checkout && data.all_checkin_checkout.length > 0 ? (
                  <div style={{ padding: '2px 6px', borderBottom: bDot, display: 'flex', alignItems: 'flex-start' }}>
                    <div
                      style={{
                        width: 90,
                        fontSize: 11,
                        color: 'rgb(34, 34, 34)',
                        fontWeight: 400,
                        textTransform: 'uppercase',
                        display: 'inline-block',
                        verticalAlign: 'top'
                      }}
                    >
                      Guests
                    </div>
                    <div style={{ paddingRight: 2 }}>:</div>
                    <div style={{ display: 'inline-block', fontSize: 11, color: 'rgb(85, 85, 85)' }}>
                      {data.all_checkin_checkout.map((checkout, idx) => (
                        <div key={idx}>
                          {moment(checkout.book_from).format('DD-MM-YYYY')} to{' '}
                          {moment(checkout.book_to).format('DD-MM-YYYY')} (
                          {checkout.adult} Adult{checkout.adult > 1 ? 's' : ''}
                          {checkout.child > 0 ? `, ${checkout.child} Child${checkout.child > 1 ? 'ren' : ''}` : ''}
                          )
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <>
                    {fieldRow('Adults', String(data?.adult || 0))}
                    {fieldRow('Children', String(data?.child || 0))}
                  </>
                )}
              </div>
            </div>

            {/* ===== ROOM CHARGES ===== */}
            {!['group', 'package', 'customized'].includes(data?.booking_master_details?.template_type) && !data?.booking_master_details?.hide_breakup && !props.paymentDetailsResend && (
              <>
                {sectionTitle('Room Charges')}
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={thStyle({ textAlign: 'left', width: '16%' })}>Date</th>
                      <th style={thStyle({ textAlign: 'left', width: '15%' })}>Type</th>
                      <th style={thStyle({ width: '5%', textAlign: 'center' })}>Room(s)</th>

                      <th style={thStyle({ textAlign: 'right', width: '10%' })}>Unit Rate</th>
                      <th style={thStyle({ textAlign: 'right', width: '10%' })}>Total</th>
                      {hasProportionateDiscount && <th style={thStyle({ textAlign: 'right', width: '10%' })}>Disc</th>}
                      <th style={thStyle({ textAlign: 'right', width: '10%' })}>
                        Net Amt.
                      </th>
                      {/* {!noTax && <th style={thStyle({ textAlign: 'right', width: '10%' })}>GST</th>} */}
                      {!noTax && hasCGST && <th style={thStyle({ textAlign: 'right', width: '10%' })}>CGST</th>}
                      {!noTax && hasSGST && <th style={thStyle({ textAlign: 'right', width: '10%' })}>SGST</th>}
                      {!noTax && hasIGST && <th style={thStyle({ textAlign: 'right', width: '10%' })}>IGST</th>}

                      <th style={thStyle({ textAlign: 'right', borderRight: 'none', width: '12%' })}>Payable ({cs})</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roomRows.map((r, i) => {
                      const cgstAmount = Number(r.cgst_amount || 0) * Number(r.day_count || 1);
                      const sgstAmount = Number(r.sgst_amount || 0) * Number(r.day_count || 1);
                      const igstAmount = Number(r.igst_amount || 0) * Number(r.day_count || 1);
                      const totalGst = cgstAmount + sgstAmount + igstAmount;
                      const proportionateDiscount = Number(r.proportionate_discount || 0);
                      const subRoomTotal = Number(r.room_rate || 0) + totalGst;
                      const roomTotal = Number(r.room_rate || 0) - proportionateDiscount + totalGst;
                      const gstPercent = Number(r.gst_percent || 0);
                      return (
                        <tr key={i}>
                          <td style={cell({ textAlign: 'left' })}>{moment(r.book_from).format('DD-MM-YYYY')}</td>
                          {data?.booking_master_details?.is_slot_booking ? (
                            <td style={cell({ textAlign: 'left' })}>
                              {r.room_type_name}
                              <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>
                                {`(${data?.booking_master_details?.slot_time_span} hour${data?.booking_master_details?.slot_time_span !== 1 ? "s" : ""})`}
                                • Room: {r.room_no === '0' || r.room_no === 0 ? 'N/A' : r.room_no}
                              </div>
                              {JSON.parse(r?.mealPlans)?.length > 0 &&
                                <VariantViewPanel variants={JSON.parse(r?.mealPlans)} rowData={r} />
                              }
                            </td>)
                            : (<td style={cell({ textAlign: 'left' })}>
                              {r.room_type_name}
                              <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>
                                {r.day_count} {r.day_count > 1 ? 'Nights' : 'Night'} • Room: {r.room_no === '0' || r.room_no === 0 ? 'N/A' : r.room_no}
                              </div>
                              {JSON.parse(r?.mealPlans)?.length > 0 &&
                                <VariantViewPanel variants={JSON.parse(r?.mealPlans)} rowData={r} />
                              }
                            </td>)}
                          <td style={cell({ textAlign: 'center' })}>{r.room_count}</td>

                          <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(r.perday_rent)}</td>
                          <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(r.room_rate)}</td>
                          {hasProportionateDiscount && <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{proportionateDiscount > 0 ? fmt(proportionateDiscount) : '—'}</td>}
                          <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>
                            {(Number(r.room_rate || 0) - Number(proportionateDiscount || 0)).toFixed(2)}
                          </td>
                          {!noTax && hasCGST && (
                            <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>
                              {cgstAmount > 0 ? (
                                <div>
                                  <div>{fmt(cgstAmount)}</div>
                                  <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>{fmt(gstPercent / 2)}%</div>
                                </div>
                              ) : '—'}
                            </td>
                          )}
                          {!noTax && hasSGST && (
                            <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>
                              {sgstAmount > 0 ? (
                                <div>
                                  <div>{fmt(sgstAmount)}</div>
                                  <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>{fmt(gstPercent / 2)}%</div>
                                </div>
                              ) : '—'}
                            </td>
                          )}
                          {!noTax && hasIGST && (
                            <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>
                              {igstAmount > 0 ? (
                                <div>
                                  <div>{fmt(igstAmount)}</div>
                                  <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>{fmt(gstPercent)}%</div>
                                </div>
                              ) : '—'}
                            </td>
                          )}

                          <td
                            style={cell({
                              textAlign: 'right',
                              fontWeight: 600,
                              borderRight: 'none',
                              fontFamily: 'Poppins-Regular',
                            })}
                          >
                            {fmt(roomTotal)}
                          </td>
                        </tr>
                      );
                    })}
                    {/* Summary Row */}
                    <tr style={{ backgroundColor: '#f0f0f0', fontWeight: 600 }}>
                      <td style={{ ...cell({ textAlign: 'left' }), borderTop: '2px solid #333', borderRight: 'none' }} colSpan="3"></td>
                      <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}></td>
                      <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                        {fmt(roomRows.reduce((sum, r) => sum + Number(r.room_rate || 0), 0))}
                      </td>
                      {hasProportionateDiscount && (
                        <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                          {fmt(roomRows.reduce((sum, r) => sum + Number(r.proportionate_discount || 0), 0))}
                        </td>
                      )}
                      <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                        {fmt(roomRows.reduce((sum, r) => {
                          const proportionateDiscount = Number(r.proportionate_discount || 0);
                          return sum + Number(r.room_rate || 0) - proportionateDiscount;
                        }, 0))}
                      </td>
                      {!noTax && hasCGST && (
                        <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                          {fmt(roomRows.reduce((sum, r) => {
                            const cgst = Number(r.cgst_amount || 0) * Number(r.day_count || 1);
                            return sum + cgst;
                          }, 0))}
                        </td>
                      )}
                      {!noTax && hasSGST && (
                        <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                          {fmt(roomRows.reduce((sum, r) => {
                            const sgst = Number(r.sgst_amount || 0) * Number(r.day_count || 1);
                            return sum + sgst;
                          }, 0))}
                        </td>
                      )}
                      {!noTax && hasIGST && (
                        <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                          {fmt(roomRows.reduce((sum, r) => {
                            const igst = Number(r.igst_amount || 0) * Number(r.day_count || 1);
                            return sum + igst;
                          }, 0))}
                        </td>
                      )}

                      <td style={{ ...cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                        {fmt(roomRows.reduce((sum, r) => {
                          const cgst = Number(r.cgst_amount || 0) * Number(r.day_count || 1);
                          const sgst = Number(r.sgst_amount || 0) * Number(r.day_count || 1);
                          const igst = Number(r.igst_amount || 0) * Number(r.day_count || 1);
                          const totalGst = cgst + sgst + igst;
                          const proportionateDiscount = Number(r.proportionate_discount || 0);
                          return sum + Number(r.room_rate || 0) + totalGst;
                        }, 0))}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ borderTop: b, backgroundColor: '#f9f9f9' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: '0' }}>
                    {summaryRow('GROSS AMOUNT (ROOM)', `${cs} ${fmt(roomTotal)}`, true, false)}
                  </div>
                </div>
              </>)}

            {/* ===== FOODING DETAILS ===== */}
            {!['group', 'package', 'customized'].includes(data?.booking_master_details?.template_type) && !data?.booking_master_details?.hide_breakup && hasFoodData && foodTotal > 0 && !props.paymentDetailsResend && (
              <>
                {sectionTitle('Fooding Details')}
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={thStyle({ textAlign: 'left', width: '15%' })}>Date</th>
                      <th style={thStyle({ width: '10%' })}>Unit</th>
                      <th style={thStyle({ textAlign: 'center', width: '10%' })}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                          <span>Breakfast</span>
                          <span>Rate</span>
                        </div>
                      </th>
                      <th style={thStyle({ textAlign: 'right', width: '10%' })}>Sub Total</th>
                      <th style={thStyle({ textAlign: 'center', width: '10%' })}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                          <span>Lunch</span>
                          <span>Rate</span>
                        </div>
                      </th>
                      <th style={thStyle({ textAlign: 'right', width: '10%' })}>Sub Total</th>
                      <th style={thStyle({ textAlign: 'center', width: '10%' })}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                          <span>Dinner</span>
                          <span>Rate</span>
                        </div>
                      </th>
                      <th style={thStyle({ textAlign: 'right', width: '10%' })}>Sub Total</th>
                      <th style={thStyle({ textAlign: 'right', borderRight: 'none', width: '15%' })}>Total ({cs})</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(data.date_wise_food_hash).map((dateKey, i) => {
                      const dayData = data.date_wise_food_hash[dateKey];
                      return Object.keys(dayData).map((ageRange, j) => {
                        const fd = dayData[ageRange];
                        const bAmt = fd.is_breakfast_available ? Number(fd.breakfast_rate) * fd.head_count : 0;
                        const lAmt = fd.is_lunch_available ? Number(fd.lunch_rate) * fd.head_count : 0;
                        const dAmt = fd.is_dinner_available ? Number(fd.dinner_rate) * fd.head_count : 0;
                        const totalAmt = bAmt + lAmt + dAmt;

                        return (
                          <tr key={`${i}-${j}`}>
                            <td style={cell({ textAlign: 'left' })}>{moment(dateKey).format('DD-MM-YYYY')}</td>
                            <td style={cell({ textAlign: 'center' })}>{fd.head_count}</td>
                            <td style={cell({ textAlign: 'right' })}>
                              {fd.is_breakfast_available ? (
                                <div>
                                  {fmt(fd.breakfast_rate)}
                                </div>
                              ) : (
                                <div style={{ textAlign: 'center', color: '#999' }}>—</div>
                              )}
                            </td>
                            <td style={cell({ textAlign: 'right' })}>
                              {fd.is_breakfast_available ? (
                                <div>
                                  {fmt(Number(fd.breakfast_rate || 0) * Number(fd.head_count || 0))}
                                </div>
                              ) : (
                                <div style={{ textAlign: 'center', color: '#999' }}>—</div>
                              )}
                            </td>
                            <td style={cell({ textAlign: 'right' })}>
                              {fd.is_lunch_available ? (
                                <div>
                                  {fmt(fd.lunch_rate)}
                                </div>
                              ) : (
                                <div style={{ textAlign: 'center', color: '#999' }}>—</div>
                              )}
                            </td>
                            <td style={cell({ textAlign: 'right' })}>
                              {fd.is_lunch_available ? (
                                <div>
                                  {fmt(Number(fd.lunch_rate || 0) * Number(fd.head_count || 0))}
                                </div>
                              ) : (
                                <div style={{ textAlign: 'center', color: '#999' }}>—</div>
                              )}
                            </td>
                            <td style={cell({ textAlign: 'right' })}>
                              {fd.is_dinner_available ? (
                                <div>
                                  {fmt(fd.dinner_rate)}
                                </div>
                              ) : (
                                <div style={{ textAlign: 'center', color: '#999' }}>—</div>
                              )}
                            </td>
                            <td style={cell({ textAlign: 'right' })}>
                              {fd.is_dinner_available ? (
                                <div>
                                  {fmt(Number(fd.dinner_rate || 0) * Number(fd.head_count || 0))}
                                </div>
                              ) : (
                                <div style={{ textAlign: 'center', color: '#999' }}>—</div>
                              )}
                            </td>
                            <td style={cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' })}>
                              {fmt(totalAmt)}
                            </td>
                          </tr>
                        );
                      });
                    })}
                    {/* Summary Row */}
                    {(() => {
                      let totalBreakfastPersons = 0;
                      let totalBreakfastRate = 0;
                      let totalBreakfastAmount = 0;
                      let totalLunchPersons = 0;
                      let totalLunchRate = 0;
                      let totalLunchAmount = 0;
                      let totalDinnerPersons = 0;
                      let totalDinnerRate = 0;
                      let totalDinnerAmount = 0;
                      let grandTotal = 0;

                      Object.keys(data.date_wise_food_hash).forEach((dateKey) => {
                        const dayData = data.date_wise_food_hash[dateKey];
                        Object.keys(dayData).forEach((ageRange) => {
                          const fd = dayData[ageRange];
                          if (fd.is_breakfast_available) {
                            totalBreakfastPersons += Number(fd.head_count || 0);
                            totalBreakfastRate = Number(fd.breakfast_rate || 0);
                            totalBreakfastAmount += Number(fd.breakfast_rate || 0) * Number(fd.head_count || 0);
                          }
                          if (fd.is_lunch_available) {
                            totalLunchPersons += Number(fd.head_count || 0);
                            totalLunchRate = Number(fd.lunch_rate || 0);
                            totalLunchAmount += Number(fd.lunch_rate || 0) * Number(fd.head_count || 0);
                          }
                          if (fd.is_dinner_available) {
                            totalDinnerPersons += Number(fd.head_count || 0);
                            totalDinnerRate = Number(fd.dinner_rate || 0);
                            totalDinnerAmount += Number(fd.dinner_rate || 0) * Number(fd.head_count || 0);
                          }
                        });
                      });

                      grandTotal = totalBreakfastAmount + totalLunchAmount + totalDinnerAmount;

                      return (
                        <tr style={{ backgroundColor: '#f0f0f0', fontWeight: 600 }}>
                          <td style={{ ...cell({ textAlign: 'left' }), borderTop: '2px solid #333', borderRight: 'none' }} colSpan={2}></td>
                          <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}></td>
                          <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                            {totalBreakfastPersons > 0 ? (
                              <div>
                                <div style={{ marginTop: 2 }}> {cs}{fmt(totalBreakfastAmount)}</div>
                              </div>
                            ) : (
                              <div style={{ textAlign: 'center', color: '#999' }}>—</div>
                            )}
                          </td>
                          <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}></td>
                          <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                            {totalLunchPersons > 0 ? (
                              <div>
                                <div style={{ marginTop: 2 }}> {cs}{fmt(totalLunchAmount)}</div>
                              </div>
                            ) : (
                              <div style={{ textAlign: 'center', color: '#999' }}>—</div>
                            )}
                          </td>
                          <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}></td>
                          <td style={{ ...cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                            {totalDinnerPersons > 0 ? (
                              <div>
                                <div style={{ marginTop: 2 }}> {cs}{fmt(totalDinnerAmount)}</div>
                              </div>
                            ) : (
                              <div style={{ textAlign: 'center', color: '#999' }}>—</div>
                            )}
                          </td>

                          <td style={{ ...cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' }), borderTop: '2px solid #333' }}>
                            {fmt(grandTotal)}
                          </td>
                        </tr>
                      );
                    })()}
                  </tbody>
                </table>


                <div style={{ borderTop: b }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: '0' }}>
                    {foodDiscount > 0 && summaryRow(
                      <span>Discount{data?.special_discount_perc_for_food && data.special_discount_perc_for_food !== '' && <span style={{ color: '#666' }}> ({data.special_discount_perc_for_food}%)</span>}</span>,
                      `${cs} ${fmt(foodDiscount)}`,
                      false
                    )}
                    {!noTax && (foodBaseAmount - foodDiscount) > 0 && summaryRow('Net Amt.', `${cs} ${fmt(foodBaseAmount - foodDiscount)}`, false)}
                    {!noTax && foodCgst > 0 && summaryRow(<span>CGST <span style={{ color: '#666' }}>({fmt(data?.fcgst_percent)}%)</span></span>, `${cs} ${fmt(foodCgst)}`, false)}
                    {!noTax && foodSgst > 0 && summaryRow(<span>SGST <span style={{ color: '#666' }}>({fmt(data?.fsgst_percent)}%)</span></span>, `${cs} ${fmt(foodSgst)}`, false)}
                    {!noTax && foodIgst > 0 && summaryRow(<span>IGST <span style={{ color: '#666' }}>({fmt(data?.fgst_percent)}%)</span></span>, `${cs} ${fmt(foodIgst)}`, false)}
                  </div>
                </div>
                <div style={{ borderTop: b, backgroundColor: '#f9f9f9' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: '0' }}>
                    {summaryRow('GROSS AMOUNT (FOOD)', `${cs} ${fmt(foodTotal)}`, true, false)}
                  </div>
                </div>
              </>
            )}

            {/* ===== CONSUMPTION / DAMAGE ITEMS ===== */}
            {allItems.length > 0 && !props.paymentDetailsResend && (
              <>
                {sectionTitle('Consumption / Damage Items')}
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={thStyle({ width: '5%' })}>#</th>
                      <th style={thStyle({ textAlign: 'left' })}>Item</th>
                      <th style={thStyle()}>Type</th>
                      <th style={thStyle()}>Qty</th>
                      <th style={thStyle({ textAlign: 'right' })}>Rate</th>
                      <th style={thStyle({ textAlign: 'right' })}>Amount</th>
                      {!noTax && <th style={thStyle()}>GST%</th>}
                      {!noTax && <th style={thStyle({ textAlign: 'right' })}>CGST</th>}
                      {!noTax && <th style={thStyle({ textAlign: 'right' })}>SGST</th>}
                      <th style={thStyle({ textAlign: 'right', borderRight: 'none' })}>Total ({cs})</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allItems.map((item, idx) => (
                      <tr key={idx}>
                        <td style={cell({ textAlign: 'center' })}>{idx + 1}</td>
                        <td style={cell({ textAlign: 'left' })}>{item.item_name}</td>
                        <td style={cell({ textAlign: 'center' })}>{item.type}</td>
                        <td style={cell({ textAlign: 'center' })}>{item.quantity}</td>
                        <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(item.charge_per_unit)}</td>
                        <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(item.amount)}</td>
                        {!noTax && <td style={cell({ textAlign: 'center' })}>{item.gst}%</td>}
                        {!noTax && <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(item.cgst)}</td>}
                        {!noTax && <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(item.sgst)}</td>}
                        <td
                          style={cell({
                            textAlign: 'right',
                            fontWeight: 600,
                            borderRight: 'none',
                            fontFamily: 'Poppins-Regular',
                          })}
                        >
                          {fmt(item.total)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ borderTop: b }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    {summaryRow('Subtotal', `${cs} ${fmt(consumedSubtotal)}`, false)}
                    {!noTax && consumedTaxTotal > 0 && summaryRow('Tax', `${cs} ${fmt(consumedTaxTotal)}`, false)}
                    {summaryRow('ITEMS TOTAL', `${cs} ${fmt(consumedTotal)}`, true, true)}
                  </div>
                </div>
              </>
            )}

            {/* ===== CONSUMPTION/DAMAGE ITEM DETAILS ===== */}
            {hasDetailedItems && !props.paymentDetailsResend && (
              <>
                {sectionTitle('Consumption/Damage Item Details')}
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={thStyle({ width: '5%' })}>#</th>
                      <th style={thStyle({ textAlign: 'left', width: '25%', maxWidth: 300 })}>Description</th>
                      <th style={thStyle({ width: '15%' })}>Type</th>
                      <th style={thStyle({ width: '10%' })}>Qty</th>
                      <th style={thStyle({ textAlign: 'right', width: '12%' })}>Rate ({cs})</th>
                      <th style={thStyle({ textAlign: 'right', width: '12%' })}>Amount ({cs})</th>
                      {!noTax && (
                        <>
                          <th style={thStyle({ width: '10%' })}>GST%</th>
                          <th style={thStyle({ textAlign: 'right', borderRight: 'none', width: '11%' })}>Total ({cs})</th>
                        </>
                      )}
                      {noTax && <th style={thStyle({ textAlign: 'right', borderRight: 'none', width: '21%' })}>Total ({cs})</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {detailedConsumptionItems.map((item, idx) => {
                      const qty = Number(item.quantity_used || 0);
                      const rate = Number(item.selling_cost || 0);
                      const amount = Number(item.total_cost || 0);
                      const gstPercent = Number(item.sgst_perc || 0) + Number(item.cgst_perc || 0);
                      const total = Number(item.total_cost_including_tax || 0);
                      return (
                        <tr key={`cons-${idx}`}>
                          <td style={cell({ textAlign: 'center' })}>{idx + 1}</td>
                          <td style={cell({ textAlign: 'left', maxWidth: 300 })}>{item.item_name}</td>
                          <td style={cell({ textAlign: 'center' })}>Consumption</td>
                          <td style={cell({ textAlign: 'center' })}>{qty}</td>
                          <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(rate)}</td>
                          <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(amount)}</td>
                          {!noTax && (
                            <>
                              <td style={cell({ textAlign: 'center' })}>{gstPercent}%</td>
                              <td style={cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' })}>
                                {fmt(total)}
                              </td>
                            </>
                          )}
                          {noTax && (
                            <td style={cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' })}>
                              {fmt(amount)}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                    {detailedDamageItems.map((item, idx) => {
                      const qty = Number(item.quantity || 0);
                      const rate = Number(item.charge_per_unit || 0);
                      const amount = Number(item.total_charge || 0);
                      const gstPercent = 0; // Damage items typically don't have GST
                      const total = Number(item.total_charge || 0);
                      return (
                        <tr key={`dmg-${idx}`}>
                          <td style={cell({ textAlign: 'center' })}>{detailedConsumptionItems.length + idx + 1}</td>
                          <td style={cell({ textAlign: 'left' })}>{item.item_name}</td>
                          <td style={cell({ textAlign: 'center' })}>Damage</td>
                          <td style={cell({ textAlign: 'center' })}>{qty}</td>
                          <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(rate)}</td>
                          <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(amount)}</td>
                          {!noTax && (
                            <>
                              <td style={cell({ textAlign: 'center' })}>{gstPercent}%</td>
                              <td style={cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' })}>
                                {fmt(total)}
                              </td>
                            </>
                          )}
                          {noTax && (
                            <td style={cell({ textAlign: 'right', fontWeight: 600, borderRight: 'none', fontFamily: 'Poppins-Regular' })}>
                              {fmt(amount)}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div style={{ borderTop: b }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    {summaryRow('Subtotal', `${cs} ${fmt(detailedSubtotalAmount)}`, false)}
                    {!noTax && (detailedSubtotalCGST + detailedSubtotalSGST) > 0 &&
                      summaryRow('Tax', `${cs} ${fmt(detailedSubtotalCGST + detailedSubtotalSGST)}`, false)}
                    {summaryRow('TOTAL', `${cs} ${fmt(detailedSubtotalTotal)}`, true, true)}
                  </div>
                </div>
              </>
            )}

            {/* ===== EARLY CHECKOUT ROOM DETAILS ===== */}
            {isEarlyCheckout && !data?.booking_master_details?.hide_breakup && earlyRoomRows.length > 0 && !props.paymentDetailsResend && (() => {
              // Calculate totals
              let totalDiscount = 0;
              let totalCgst = 0;
              let totalSgst = 0;
              let totalIgst = 0;
              let totalRoomAmount = 0;

              earlyRoomRows.forEach((r) => {
                const cgstAmount = Number(r.cgst_amount || 0) * Number(r.day_count || 1);
                const sgstAmount = Number(r.sgst_amount || 0) * Number(r.day_count || 1);
                const igstAmount = Number(r.igst_amount || 0) * Number(r.day_count || 1);
                const proportionateDiscount = Number(r.proportionate_discount || 0);
                const basePrice = Number(r.room_rate || 0);

                totalDiscount += proportionateDiscount;
                totalCgst += cgstAmount;
                totalSgst += sgstAmount;
                totalIgst += igstAmount;
                totalRoomAmount += basePrice - proportionateDiscount + cgstAmount + sgstAmount + igstAmount;
              });

              if (totalRoomAmount <= 0) return null;

              const dates = earlyRoomRows.map(r => r.book_from);
              const fromDate = dates[0];
              const toDate = earlyRoomRows[earlyRoomRows.length - 1].book_to;

              return (
                <>
                  {sectionTitle('Early Check-out — Room Details')}
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={thStyle({ textAlign: 'center', width: '20%' })}>From Date</th>
                        <th style={thStyle({ textAlign: 'center', width: '20%' })}>To Date</th>
                        <th style={thStyle({ textAlign: 'right', width: '15%' })}>Discount ({cs})</th>
                        {!noTax && data?.booking_master_details?.is_igst_applicable ? (
                          <th style={thStyle({ textAlign: 'right', width: '15%' })}>IGST ({cs})</th>
                        ) : (
                          <>
                            <th style={thStyle({ textAlign: 'right', width: '15%' })}>CGST ({cs})</th>
                            <th style={thStyle({ textAlign: 'right', width: '15%' })}>SGST ({cs})</th>
                          </>
                        )}
                        <th style={thStyle({ textAlign: 'right', borderRight: 'none', width: '15%' })}>Total Amount ({cs})</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={cell({ textAlign: 'center' })}>{moment(fromDate).format('DD-MM-YYYY')}</td>
                        <td style={cell({ textAlign: 'center' })}>{moment(toDate).format('DD-MM-YYYY')}</td>
                        <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(totalDiscount)}</td>
                        {!noTax && data?.booking_master_details?.is_igst_applicable ? (
                          <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(totalIgst)}</td>
                        ) : (
                          <>
                            <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(totalCgst)}</td>
                            <td style={cell({ textAlign: 'right', fontFamily: 'Poppins-Regular' })}>{fmt(totalSgst)}</td>
                          </>
                        )}
                        <td
                          style={cell({
                            textAlign: 'right',
                            fontWeight: 600,
                            borderRight: 'none',
                            fontFamily: 'Poppins-Regular',
                          })}
                        >
                          {fmt(totalRoomAmount)}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* GROSS AMOUNT only */}
                  <div style={{ borderTop: b, backgroundColor: '#f9f9f9' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: '0' }}>
                      {summaryRow('GROSS AMOUNT', `${cs} ${fmt(totalRoomAmount)}`, true, false)}
                    </div>
                  </div>
                </>
              );
            })()}

            {/* ===== EARLY CHECKOUT FOOD ===== */}
            {isEarlyCheckout && !data?.booking_master_details?.hide_breakup && Object.keys(earlyFoodHash).length > 0 && !props.paymentDetailsResend && (() => {
              // Calculate total food amount first to check if we should display the section
              let totalFoodAmount = 0;
              Object.keys(earlyFoodHash).forEach((dateKey) => {
                const dayData = earlyFoodHash[dateKey];
                Object.keys(dayData).forEach((ageRange) => {
                  const fd = dayData[ageRange];
                  const bAmt = fd.is_breakfast_available ? Number(fd.breakfast_rate) * fd.head_count : 0;
                  const lAmt = fd.is_lunch_available ? Number(fd.lunch_rate) * fd.head_count : 0;
                  const dAmt = fd.is_dinner_available ? Number(fd.dinner_rate) * fd.head_count : 0;
                  totalFoodAmount += bAmt + lAmt + dAmt;
                });
              });

              // Only display if total amount is greater than 0
              if (totalFoodAmount <= 0) return null;

              const dates = Object.keys(earlyFoodHash);
              const fromDate = dates[0];
              const toDate = dates[dates.length - 1];

              return (
                <>
                  {sectionTitle('Early Check-out — Food Details')}
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={thStyle({ textAlign: 'center' })}>From Date</th>
                        <th style={thStyle({ textAlign: 'center' })}>To Date</th>
                        <th style={thStyle({ textAlign: 'right', borderRight: 'none' })}>Total Amount ({cs})</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={cell({ textAlign: 'center' })}>{moment(fromDate).format('DD-MM-YYYY')}</td>
                        <td style={cell({ textAlign: 'center' })}>{moment(toDate).format('DD-MM-YYYY')}</td>
                        <td
                          style={cell({
                            textAlign: 'right',
                            fontWeight: 600,
                            borderRight: 'none',
                            fontFamily: 'Poppins-Regular',
                          })}
                        >
                          {fmt(totalFoodAmount)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              );
            })()}

            {/* ===== EARLY CHECKOUT GRAND TOTAL ===== */}
            {isEarlyCheckout &&
              (Number(data?.full_cancelation_details?.extra_amount) > 0 ||
                Number(data?.full_cancelation_details?.extra_discount) > 0) && !props.paymentDetailsResend && (
                <div style={{ borderTop: b }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    {summaryRow('Total (Inc. Tax)', `${cs} ${fmt(data?.full_cancelation_details?.total_amount_to_pay)}`, false)}
                    {Number(data?.full_cancelation_details?.extra_discount) > 0 &&
                      summaryRow('Discount', `${cs} ${fmt(data?.full_cancelation_details?.extra_discount)}`, false)}
                    {summaryRow('GROSS AMOUNT', `${cs} ${fmt(data?.full_cancelation_amount)}`, true, true)}
                  </div>
                </div>
              )}

            {/* ===== PAYABLE SERVICE DETAILS ===== */}
            {extraService.length > 0 && !data?.booking_master_details?.hide_breakup && extraService.some(item => !item.hasOwnProperty('note_type') || item.note_type !== 'BILL_POSTING') && !props.paymentDetailsResend && (
              <>
                {sectionTitle('Payable Service Details')}
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={thStyle()}>Date</th>
                      <th style={thStyle({ textAlign: 'left', maxWidth: 300 })}>Description</th>

                      <th style={thStyle({ textAlign: 'right' })}>Amount ({cs})</th>
                      {!noTax && (
                        <>
                          <th style={thStyle()}>Tax (%)</th>
                          <th style={thStyle({ textAlign: 'right', borderRight: 'none' })}>Total ({cs})</th>
                        </>
                      )}
                      {noTax && <th style={thStyle({ textAlign: 'right', borderRight: 'none' })}>Total ({cs})</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {payableServiceDetailsUi()}
                  </tbody>
                </table>
                {Number(data?.notation_amount || 0) > 0 && (
                  <div style={{ borderTop: b }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      {summaryRow(
                        'GROSS AMOUNT FOR SERVICE',
                        `${cs} ${noTax ? fmt(totalNotationAmount) : fmt(totalNotationAmountWithTax)}`,
                        true,
                        true
                      )}
                    </div>
                  </div>
                )}
              </>
            )}

            {/* ===== PAYABLE SERVICE DETAILS (BILL POSTING) ===== */}
            {extraService.length > 0 && !data?.booking_master_details?.hide_breakup && extraService.some(item => item.hasOwnProperty('note_type') && item.note_type === 'BILL_POSTING') && !props.paymentDetailsResend && (
              <>
                {sectionTitle('Payable Service Details (Bill Posting)')}
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={thStyle({ width: '20%' })}>Date</th>
                      <th style={thStyle({ textAlign: 'left', width: '40%' })}>Description</th>

                      <th style={thStyle({ width: '20%' })}>Tax (%)</th>
                      <th style={thStyle({ textAlign: 'right', borderRight: 'none', width: '20%' })}>Total ({cs})</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payableServiceDetailsBillPostingUi()}
                  </tbody>
                </table>
                {Number(totalNotationAmountWithTaxBillPosting) > 0 && (
                  <div style={{ borderTop: b }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      {summaryRow(
                        'GROSS AMOUNT FOR SERVICE',
                        `${cs} ${fmt(totalNotationAmountWithTaxBillPosting)}`,
                        true,
                        true
                      )}
                    </div>
                  </div>
                )}
              </>
            )}

            {/* ===== PAYMENT HISTORY ===== */}
            {sectionTitle('Payment History')}
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={thStyle({ textAlign: 'left' })}>Receipt ID</th>
                  <th style={thStyle()}>Mode</th>
                  <th style={thStyle({ textAlign: 'right' })}>Amount ({cs})</th>
                  <th style={thStyle({ borderRight: 'none' })}>Date</th>
                </tr>
              </thead>
              <tbody>
                {creditedPayments.map((p, i) => (
                  <tr key={`cr-${i}`}>
                    <td style={cell({ textAlign: 'left' })}>{p.recipet_id}</td>
                    <td style={cell({ textAlign: 'center' })}>{cap(p.payment_mode)}</td>
                    <td style={cell({ textAlign: 'right', fontWeight: 600, fontFamily: 'Poppins-Regular' })}>+ {fmt(p.amount)}</td>
                    <td style={cell({ textAlign: 'center', borderRight: 'none' })}>{moment(p.payment_date).format('DD-MM-YYYY HH:mm')}</td>
                  </tr>
                ))}
                {debitedPayments.map((p, i) => (
                  <tr key={`dr-${i}`}>
                    <td style={cell({ textAlign: 'left' })}>{p.recipet_id}</td>
                    <td style={cell({ textAlign: 'center' })}>{cap(p.payment_mode)}</td>
                    <td style={cell({ textAlign: 'right', fontWeight: 600, fontFamily: 'Poppins-Regular' })}>- {fmt(p.amount)}</td>
                    <td style={cell({ textAlign: 'center', borderRight: 'none' })}>{moment(p.payment_date).format('DD-MM-YYYY HH:mm')}</td>
                  </tr>
                ))}
                {creditedPayments.length === 0 && debitedPayments.length === 0 && (
                  <tr>
                    <td colSpan={4} style={cell({ textAlign: 'center', color: '#999', fontStyle: 'italic', borderRight: 'none' })}>
                      No payments recorded
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* ===== GRAND BILLING SUMMARY ===== */}
            <div style={{ borderTop: '2px solid #333' }}>
              <div style={{ display: 'flex', borderBottom: '2px solid rgb(51, 51, 51)' }}>
                {/* Notes */}
                <div style={{ flex: 1, borderRight: b, padding: '8px 10px', fontSize: 12, color: '#666', lineHeight: 1.6 }}>
                  {data.hasOwnProperty('extra_notes') && data.extra_notes && data.extra_notes.length > 0 ?
                    <div>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: 12,
                          marginBottom: 3,
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          color: '#333',
                        }}
                      >
                        Notes
                      </div>
                      <div dangerouslySetInnerHTML={{ __html: data?.extra_notes || '' }} />
                    </div> : null}
                  {bankDetails && (
                    <div style={{ marginTop: data.hasOwnProperty('extra_notes') && data.extra_notes && data.extra_notes.length > 0 ? 8 : 0, paddingTop: data.hasOwnProperty('extra_notes') && data.extra_notes && data.extra_notes.length > 0 ? 6 : 0, borderTop: data.hasOwnProperty('extra_notes') && data.extra_notes && data.extra_notes.length > 0 ? borderLight : 'none' }}>
                      <div style={{ fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '1px', color: '#333', marginBottom: 3 }}>Bank Details</div>
                      <div style={{ fontSize: 11, lineHeight: 1.6 }}>
                        {bankDetails.bank && <div>Bank: {bankDetails.bank}</div>}
                        {bankDetails.branch && <div>Branch: {bankDetails.branch}</div>}
                        {bankDetails.account_no && <div>A/C: {bankDetails.account_no}</div>}
                        {bankDetails.ifsc_code && <div>IFSC: {bankDetails.ifsc_code}</div>}
                        {bankDetails.account_holder_name && <div>Name: {bankDetails.account_holder_name}</div>}
                      </div>
                    </div>
                  )}
                </div>

                {/* Summary */}
                <div style={{ width: 280 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: bDot, fontSize: 12 }}>
                    <span>Booking Amount</span>
                    <span style={{ fontFamily: 'Poppins-Regular', fontWeight: 400 }}>
                      {cs} {fmt(data?.total_amount)}
                    </span>
                  </div>

                  {Number(data.special_discount) > 0 ?
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: bDot, fontSize: 12 }}>
                      <span>Special Room Discount{data.special_discount_perc && data.special_discount_perc != "" ? "(" + data.special_discount_perc + "%)" : null}</span>
                      <span style={{ fontFamily: 'Poppins-Regular', fontWeight: 400 }}>
                        - {cs} {fmt(Number(data.special_discount))}
                      </span>
                    </div>
                    : null}

                  {Number(data.special_discount_for_food) > 0 ?
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: bDot, fontSize: 12 }}>
                      <span>Special Food Discount{data.special_discount_perc_for_food && data.special_discount_perc_for_food != "" ? "(" + data.special_discount_perc_for_food + "%)" : null}</span>
                      <span style={{ fontFamily: 'Poppins-Regular', fontWeight: 400 }}>
                        - {cs} {fmt(Number(data.special_discount_for_food))}
                      </span>
                    </div>
                    : null}
                  {totalDebited > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: bDot, fontSize: 12 }}>
                      <span>Less Amount</span>
                      <span style={{ fontFamily: 'Poppins-Regular', fontWeight: 400 }}>
                        - {cs} {fmt(totalDebited)}
                      </span>
                    </div>
                  )}

                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: bDot, fontSize: 12, fontWeight: 600 }}>
                    <span>Invoice Amount</span>
                    <span style={{ fontFamily: 'Poppins-Regular', fontWeight: 600 }}>
                      {cs} {fmt(data?.total_paid)}
                    </span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: bDot, fontSize: 12 }}>
                    <span style={{ minWidth: 80 }}>Amt (Words): </span>
                    <span style={{ textAlign: 'right' }}>{numberToWords(data?.total_paid || data?.total_paid, data?.currency || 'INR')} Only</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: bDot, fontSize: 12 }}>
                    <span>Total Paid</span>
                    <span style={{ fontFamily: 'Poppins-Regular', fontWeight: 400 }}>
                      {cs} {fmt(data?.total_paid)}
                    </span>
                  </div>
                  {Number(data?.round_off_amount) !== 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: bDot, fontSize: 12 }}>
                      <span>Round Off</span>
                      <span style={{ fontFamily: 'Poppins-Regular', fontWeight: 400 }}>
                        {cs} {fmt(data?.round_off_amount)}
                      </span>
                    </div>
                  )}
                  {/* <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: bDot, fontSize: 12 }}>
                    <span>Due Amount</span>
                    <span style={{ fontFamily: 'Poppins-Regular', fontWeight: 400 }}>
                      {cs} {fmt(data?.due_amt || 0)}
                    </span>
                  </div> */}

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '6px 10px',
                      fontSize: 11,
                      fontWeight: 800,
                      borderTop: '2px solid #333',
                      backgroundColor: '#f5f5f5',
                    }}
                  >
                    <span>PAYABLE AMOUNT</span>
                    <span style={{ fontFamily: 'Poppins-Regular' }}>
                      {cs} {fmt(data?.due_amt)}
                    </span>
                  </div>

                  {/* Amount in Words */}
                  {/* <div
                    style={{
                      padding: '6px 10px',
                      fontSize: 11,
                      fontStyle: 'italic',
                      color: '#555',
                      backgroundColor: '#fafafa',
                      borderTop: '1px solid #ddd',
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>Amount in Words: </span>
                    <span>{numberToWords(data?.total_amount || data?.total_amount, data?.currency || 'INR')} Only</span>
                  </div> */}
                </div>
              </div>
            </div>

            {/* ===== SIGNATURES ===== */}
            <div style={{ display: 'flex', padding: '0 16px', marginTop: 30, gap: 40 }}>
              <div style={{ flex: 1, textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid #333', height: 45 }}></div>
                <div
                  style={{
                    marginTop: 4,
                    fontSize: 11,
                    fontWeight: 600,
                    color: '#666',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                  }}
                >
                  Authorised Signatory
                </div>
              </div>
              <div style={{ flex: 1, textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid #333', height: 45 }}></div>
                <div
                  style={{
                    marginTop: 4,
                    fontSize: 11,
                    fontWeight: 600,
                    color: '#666',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                  }}
                >
                  Guest Signature
                </div>
              </div>
            </div>

            {/* ===== FOOTER ===== */}
            {/* <div
            style={{
              marginTop: 20,
              padding: '8px 16px',
              borderTop: '2px solid #333',
              textAlign: 'center',
            }}
          >
            <div style={{ fontSize: 12, fontWeight: 600, color: '#555', letterSpacing: 2, textTransform: 'uppercase' }}>
              Thank you for your patronage
            </div>
            <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>
              This is a computer-generated invoice and does not require a physical signature.
            </div>
          </div> */}
          </div>
        </div>
        {data?.posted_bills_invoice?.length > 0 && (
          <>
            <div style={{ width: '100%', paddingTop: 10 }} className="other-bill-section">
              {/* <div
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  textAlign: 'center',
                  marginBottom: 10,
                  marginTop: 10
                }}
                className='other-bill-section-header'
              >
                Food Invoice Detail(s)
              </div> */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0px'
                }}
              >
                {data.posted_bills_invoice.map((pdfUrl, index) => {
                  if (!pdfUrl) return null;
                  return (
                    <div
                      key={index}
                      className="singleInvoiceBill"
                      style={{
                        padding: 12,
                        pageBreakInside: 'avoid',
                        margin: '0px auto'
                      }}
                    >
                      <PDFRenderer pdfUrl={pdfUrl} index={index} onLoadComplete={handlePdfLoadComplete} />
                    </div>
                  )
                })}
              </div>
            </div>
          </>
        )}
      </div>
      {/* Print HTML End here */}
          <div className={`printbttn ${isPrintScreen ? 'hide-print-button' : ''}`} style={{ width: '100%', display: 'inline-block', textAlign: 'center' }}>
            <button className='modbtn' style={{ background: '#007EE6', border: '1px solid #007EE6', color: '#fff', borderRadius: '4px', fontSize: '13px', padding: '5px 20px' }} onClick={handlePrintButtonClick}>Print</button>
            <ReactToPrint
              trigger={() => <button ref={printComponentRef} style={{ display: 'none' }}>Hidden Print</button>
              }
              content={() => divPrint.current}
              pageStyle={pageStyle}
            />
            <input type="button" value="Download" className='modbtn' onClick={downloadPdfDocument} />
          </div>
      <ErrorBoundary title="PrintOptionsModal Error">
        <ModalGlobal
          show={showPrintOptionsModal}
          onHide={handleClosePrintModal}
          title="Select Print Option"
          className="modalcustomize mondimension printOptionsModal"
          footer={false}
          closeButton={true}
          saveButtonLabel="Print"
          saveButtonClassName="btn btn-primary savebtn"
          cancelShow={false}
          zoominButton={false}
          zoomoutButton={false}
          body={
            <>
              <div style={{ padding: '20px' }}>
                <div style={{ marginBottom: '20px', fontSize: '14px', fontWeight: 500, color: '#323232' }}>
                  Please select which bill(s) you would like to print:
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '12px', border: selectedPrintOption === 'stay' ? '2px solid #323232' : '2px solid #e0e0e0', borderRadius: '6px', backgroundColor: selectedPrintOption === 'stay' ? '#e8f5f7' : '#fff', transition: 'all 0.2s' }}>
                    <input
                      type="radio"
                      name="printOption"
                      value="stay"
                      checked={selectedPrintOption === 'stay'}
                      onChange={() => handlePrintOptionSelect('stay')}
                      style={{ marginRight: '12px', width: '18px', height: '18px', cursor: 'pointer' }}
                    />
                    <span style={{ fontSize: '14px', fontWeight: 500, color: '#323232' }}>Only Stay Bill</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '12px', border: selectedPrintOption === 'outsource' ? '2px solid #323232' : '2px solid #e0e0e0', borderRadius: '6px', backgroundColor: selectedPrintOption === 'outsource' ? '#e8f5f7' : '#fff', transition: 'all 0.2s' }}>
                    <input
                      type="radio"
                      name="printOption"
                      value="outsource"
                      checked={selectedPrintOption === 'outsource'}
                      onChange={() => handlePrintOptionSelect('outsource')}
                      style={{ marginRight: '12px', width: '18px', height: '18px', cursor: 'pointer' }}
                    />
                    <span style={{ fontSize: '14px', fontWeight: 500, color: '#323232' }}>Only Food Bill</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '12px', border: selectedPrintOption === 'both' ? '2px solid #323232' : '2px solid #e0e0e0', borderRadius: '6px', backgroundColor: selectedPrintOption === 'both' ? '#e8f5f7' : '#fff', transition: 'all 0.2s' }}>
                    <input
                      type="radio"
                      name="printOption"
                      value="both"
                      checked={selectedPrintOption === 'both'}
                      onChange={() => handlePrintOptionSelect('both')}
                      style={{ marginRight: '12px', width: '18px', height: '18px', cursor: 'pointer' }}
                    />
                    <span style={{ fontSize: '14px', fontWeight: 500, color: '#323232' }}>Both Stay and Food Bill(s)</span>
                  </label>
                </div>
                <div style={{ marginTop: '25px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                  <button
                    onClick={handleClosePrintModal}
                    style={{ padding: '8px 20px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', color: '#323232', cursor: 'pointer' }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleConfirmPrint}
                    style={{ padding: '8px 20px', fontSize: '13px', border: '1px solid #323232', borderRadius: '4px', backgroundColor: '#323232', color: '#fff', cursor: 'pointer' }}
                  >
                    Print
                  </button>
                </div>
              </div>
            </>
          }
        />
      </ErrorBoundary>
    </div >
  );
};

GenerateInvoiceContent.defaultProps = {
  paymentDetailsResend: false,
  callFrom: '',
  bookingId: ''
}

const mapStateToProps = (globalState) => {
  return {
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token
  };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(GenerateInvoiceContent));